import {
    setNavClient,
    setNavSite,
    setNavEquipment,
    setActiveNavClient,
    setActiveNavSite,
    setActiveNavEquipment,
    fetchNavSites,
    fetchNavEquipment
} from '../../../actions/bobActions';

import { isEmpty } from 'lodash';

export function getApplicationName(uuid) {
    let application = '';

    switch (uuid) {
        case '46d93819-f375-4d5c-b117-bb374c032862':
            application = 'energy';
            break;
        case 'ad356bf2-b9db-4bb5-922e-c3394b1a63e3':
            application = 'bob';
            break;
        case '1710345b-cf28-4a02-9bf4-df9209ff29cb':
            application = 'k2acore';
            break;
        default:
            break;
    }

    return application;
}

export function getActiveTabName (uuid) {
    let activeTab = '';

    switch (uuid) {
        // company items
        case 'ccb00d85-7b0c-44ba-bd0e-db216ef1ee46':
            activeTab = 'Client';
            break;
        case '181b15f1-dae9-4258-89ef-07941ff33025':
            activeTab = 'Site';
            break;
        case '1593c439-3150-40b5-a5eb-1328cf5a30be':
            activeTab = 'Equipment';
            break;
        case '91475757-e1be-4bf3-a228-3be5ef997494':
            activeTab = 'System';
            break;
        case '82365757-e1be-4bf3-a228-3be5ef934586':
            activeTab = 'Health Monitor';
            break;
        // client items
        case 'f6ba2344-ba47-42c5-a98b-978365ca3936':
            activeTab = 'Site';
            break;
        case '8404408d-ad6f-472e-b9dd-34383b392178':
            activeTab = 'Equipment';
            break;
        case 'e3b10bc7-eec5-45e5-8ad2-e94c8f50ca95':
            activeTab = 'System';
            break;
        case '83456757-e1be-4bf3-a228-3be5ef934586':
            activeTab = 'Health Monitor';
            break;
        case 'c2d1445e-7e4b-4e98-95d1-72af77bf843e':
            activeTab = 'Energy';
            break;
        case '517558d4-c3f4-417d-a2d2-c10ec2f6cf2f':
            activeTab = 'Contact';
            break;
        // site items
        case 'bb5be75b-d466-48d5-99da-79cd66504f20':
            activeTab = 'Equipment';
            break;
        case '13dfff21-071c-4ee6-ab53-903fdcb5996a':
            activeTab = 'System';
            break;
        case '25fgdf16-171c-4ee6-a753-913fdcb5457b':
            activeTab = 'Faults';
            break;
        case '76543757-e1be-4bf3-a228-3be5ef934586':
            activeTab = 'Health Monitor';
            break;
        case '15dfff21-071c-4ee6-ab53-903fdcb5996a':
            activeTab = 'Scoring';
            break;
        case 'f93bff85-c8cf-4dcf-a64a-a499b927c58b':
            activeTab = 'Contact';
            break;
        // equipment items
        case '4b25aeb8-75d4-4522-9f77-870ab40abb07':
            activeTab = 'Sensors';
            break;
        case 'c49ee7a9-6a28-4820-967c-6c6a9652a4c8':
            activeTab = 'Faults';
            break;
        case '66c716c1-54ec-4b50-b6b9-9d1200ac2a78':
            activeTab = 'Rules';
            break;
        case '23453757-e1be-4bf3-a228-3be5ef934586':
            activeTab = 'Health Monitor';
            break;
        // system items
        case 'a10b6db3-ad94-43a7-a23d-861f1ffd791a':
            activeTab = 'Equipment';
            break;
        case '383849dd-bd20-4ee2-a0e5-1b192ddc4f81':
            activeTab = 'Sensors';
            break;
        case '00a75c91-5483-4c84-bb09-eb037f47bdc9':
            activeTab = 'Faults';
            break;
        case 'c2d1468e-7e4b-4e98-95d1-77af77bf843e':
            activeTab = 'Rules';
            break;
        case '45235757-e1be-4bf3-a228-3be5ef934586':
            activeTab = 'Health Monitor';
            break;
        // IotHub Items
        case 'c43ee7b9-6a28-4820-937c-6c6ag642ahc8':
            activeTab = 'BasAgent';
            break;
        case 'c4lee7b9-6ag8-4820-937c-6c65g642ahc8':
            activeTab = 'FSMAgent';
            break;
        // application menu
        case 'c2d1468e-7e4b-4e98-95d1-72af77bf843e':
            activeTab = 'Energy';
            break;
        case 'c2d1468e-7e4b-4e98-95d1-73af77bf843e':
            activeTab = 'Service';
            break;
        case 'c2d1468e-7e4b-4e98-95d1-74af77bf843e':
            activeTab = 'Schedule';
            break;
        case 'c2d1468e-7e4b-4e98-95d1-75af77bf843e':
            activeTab = 'Architect';
            break;
        case 'c2d1468e-7e4b-4e98-95d1-76af77bf843e':
            activeTab = 'Notification';
            break;
        case 'ad356bf2-b9db-4bb5-922e-c3394b1a63e3':
            activeTab = 'BOB';
            break;
        case '1710345b-cf28-4a02-9bf4-df9209ff29cb':
            activeTab = 'K2A Core';
            break;
        default:
            break;
    }

    return activeTab;
}

export const getActiveViewName = (uuid) => {
    let activeView = '';

    switch (uuid) {
        // site items
        case '4b25aeb8-77d4-4522-9f77-870ab20abb07':
            activeView = 'scoregraph';
            break;
        case '4b25aeb8-79d4-4522-9f77-870ab30abb07':
            activeView = 'scoregrid';
            break;
        // equipment items
        case '4b25aeb8-77d4-4522-9f77-870ab40abb07':
            activeView = 'sensorgraph';
            break;
        case '4b25aeb8-79d4-4522-9f77-870ab40abb07':
            activeView = 'sensorgrid';
            break;
        case '4b25aeb8-61d4-4522-9f77-870ab40abb07':
            activeView = 'overview';
            break;
        case '4b25aeb8-92d4-4522-9f77-870ab40abb07':
            activeView = 'scoregraph';
            break;
        case '4b25aeb8-45d4-4522-9f77-870ab40abb07':
            activeView = 'scoregrid';
            break;
        case '5c36bfc9-56e5-5633-0g88-981bc51bcc18':
            activeView = 'rawdata';
            break;
        case '4b25aeb8-02d4-4522-9f77-870ab40abb07':
            activeView = 'configuration';
            break;
        // system items
        case '4b25aeb8-77d4-4522-9f77-870ab40abb02':
            activeView = 'sensorgraph';
            break;
        case '4b25aeb8-79d4-4522-9f77-870ab40abb03':
            activeView = 'sensorgrid';
            break;
        case '4b25aeb8-61d4-4522-9f77-870ab40abb05':
            activeView = 'overview';
            break;
        case '4b25aeb8-92d4-4522-9f77-870ab40abb08':
            activeView = 'scoregraph';
            break;
        case '4b25aeb8-45d4-4522-9f77-870ab40abb24':
            activeView = 'scoregrid';
            break;
        case '6d47cgd0-56e5-5633-0g88-981bc51bdd29':
            activeView = 'rawdata';
            break;
        case '4b25aeb8-02d4-4522-9f77-870ab40abb74':
            activeView = 'configuration';
            break;
        default:
            break;
    }

    return activeView;
};

export const getCoreViewName = childId => {
    let activeView = '';

    switch (childId) {
        case '231b3d07-1afb-42a0-b6ff-ecb9c4dd8c48':
            activeView = 'Company Client';
            break;
        case '7d2489e6-4481-481a-8fbf-d5c0262c6539':
            activeView = 'Company Site';
            break;
        case '0da7cfdd-f757-4231-8979-7ff2b806e0a5':
            activeView = 'Company Equipment';
            break;
        case 'e979b520-3695-422d-a914-ba55c51fb316':
            activeView = 'Client Site';
            break;
        case '7e2354df-ebb5-4c68-a1a4-57cc84dd61eb':
            activeView = 'Client Equipment';
            break;
        case '2d280df7-b3fc-46ad-9e52-03437cb303f9':
            activeView = 'Client Contact';
            break;
        case '7035ee2f-b8ee-48ee-a9ac-ac522917dcdd':
            activeView = 'Site Equipment';
            break;
        case 'd0f113f5-32e1-4e2c-bf4d-386edb7f9bc4':
            activeView = 'Site System';
            break;
        case 'e00237d0-659a-4cb0-94b5-ddc158b8d417':
            activeView = 'Site Contact';
            break;
        default:
            break;
    }

    return activeView;
};

export const getEnergyViewName = id => {
    let activeView = '';

    switch (id) {
        case 'd3a45bdb-b5e7-48bf-adb3-5a469c629f20':
            activeView = 'Client Site Grid';
            break;
        case 'e4c63eaj-5je8-44bx-xaya-k5369y660h31':
            activeView = 'Client Equipment Grid';
            break;
        case '64641985-3b11-401a-b990-024d65858582':
            activeView = 'Site Power Grid';
            break;
        case '4ec708c4-0754-4f6f-9ec5-6e1b4038b07e':
            activeView = 'Site Power Graph';
            break;
        case '7ebca66c-f7af-48dc-89b3-d821409744e4':
            activeView = 'Site Heat Map';
            break;
        case '6fcdb77d-g8bg-59ed-90c4-e932510855f5':
            activeView = 'Site Equipment Grid';
            break;
        case '14dbe160-82c2-4968-accf-c2a623e8370d':
            activeView = 'Site Avoided Costs Graph';
            break;
        case 'a898fe00-ee69-4a74-b34c-8073e0f362b2':
            activeView = 'Site Future Savings Graph';
            break;
        case '4ae23613-301a-4644-b2fa-e9b3ce881e0f':
            activeView = 'Equipment Power Grid';
            break;
        case 'dfe2749b-6b32-4d66-be1d-c3151607d5db':
            activeView = 'Equipment Power Graph';
            break;
        case '8f47506a-28f2-40d4-848b-8c6f68117235':
            activeView = 'Equipment Heat Map';
            break;
        case 'd319f397-975d-4ce5-a06b-acbde43fbc2f':
            activeView = 'Equipment Avoided Costs Graph';
            break;
        case '9829f36b-65d1-41b7-aac9-b918af29f2ec':
            activeView = 'Equipment Future Savings Graph';
            break;
        default:
            break;
    }

    return activeView;
};

export const getEnergyViewId = name => {
    let activeId = '';

    switch (name) {
        case 'Client Site Grid':
            activeId = 'd3a45bdb-b5e7-48bf-adb3-5a469c629f20';
            break;
        case 'Client Energy Grid':
            activeId = 'e4c63eaj-5je8-44bx-xaya-k5369y660h31';
            break;
        case 'Site Power Grid':
            activeId = '64641985-3b11-401a-b990-024d65858582';
            break;
        case 'Site Power Graph':
            activeId = '4ec708c4-0754-4f6f-9ec5-6e1b4038b07e';
            break;
        case 'Site Heat Map':
            activeId = '7ebca66c-f7af-48dc-89b3-d821409744e4';
            break;
        case 'Site Equipment Grid':
            activeId = '6fcdb77d-g8bg-59ed-90c4-e932510855f5';
            break;
        case 'Site Avoided Costs Graph':
            activeId = '14dbe160-82c2-4968-accf-c2a623e8370d';
            break;
        case 'Site Future Savings Graph':
            activeId = 'a898fe00-ee69-4a74-b34c-8073e0f362b2';
            break;
        case 'Equipment Power Grid':
            activeId = '4ae23613-301a-4644-b2fa-e9b3ce881e0f';
            break;
        case 'Equipment Power Graph':
            activeId = 'dfe2749b-6b32-4d66-be1d-c3151607d5db';
            break;
        case 'Equipment Heat Map':
            activeId = '8f47506a-28f2-40d4-848b-8c6f68117235';
            break;
        case 'Equipment Avoided Costs Graph':
            activeId = 'd319f397-975d-4ce5-a06b-acbde43fbc2f';
            break;
        case 'Equipment Future Savings Graph':
            activeId = '9829f36b-65d1-41b7-aac9-b918af29f2ec';
            break;
        default:
            break;
    }

    return activeId;
};

export const getCoreViewId = name => {
    let activeId = '';

    switch (name) {
        case 'Company Client':
            activeId = '231b3d07-1afb-42a0-b6ff-ecb9c4dd8c48';
            break;
        case 'Company Site':
            activeId = '7d2489e6-4481-481a-8fbf-d5c0262c6539';
            break;
        case 'Company Equipment':
            activeId = '0da7cfdd-f757-4231-8979-7ff2b806e0a5';
            break;
        case 'Client Site':
            activeId = 'e979b520-3695-422d-a914-ba55c51fb316';
            break;
        case 'Client Equipment':
            activeId = '7e2354df-ebb5-4c68-a1a4-57cc84dd61eb';
            break;
        case 'Client Contact':
            activeId = '2d280df7-b3fc-46ad-9e52-03437cb303f9';
            break;
        case 'Site Equipment':
            activeId = '7035ee2f-b8ee-48ee-a9ac-ac522917dcdd';
            break;
        case 'Site System':
            activeId = 'd0f113f5-32e1-4e2c-bf4d-386edb7f9bc4';
            break;
        case 'Site Contact':
            activeId = 'e00237d0-659a-4cb0-94b5-ddc158b8d417';
            break;
        default:
            break;
    }

    return activeId;
};

export const handleNavBackNavEntities = (locationState, dispatch) => {
    if (!isEmpty(locationState.activeNavClient)) {
        dispatch(setNavClient(locationState.activeNavClient));
        dispatch(setActiveNavClient(locationState.activeNavClient));

        dispatch(fetchNavSites(locationState.activeNavClient.id));
    }
    if (!isEmpty(locationState.activeNavSite)) {
        dispatch(setNavSite(locationState.activeNavSite));
        dispatch(setActiveNavSite(locationState.activeNavSite));
        dispatch(fetchNavEquipment(locationState.activeNavSite.id));
    }
    if (!isEmpty(locationState.activeNavEquipment)) {
        dispatch(setNavEquipment(locationState.activeNavEquipment));
        dispatch(setActiveNavEquipment(locationState.activeNavEquipment));
    }
};
